import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../App.css";
import "../css/post.css";
import { API_URL_All } from "../api";
import parse from "html-react-parser";
import ScrollButton from '../component/ScrollButton';

const PostDetail = () => {
  const { id } = useParams();
  const { link } = useParams();
  const [post, setPost] = useState(null);
  const [h1List, setH1List] = useState([]);
  const [parsedContent, setParsedContent] = useState(null);

  const relatedArticles = [];

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(`${API_URL_All}/api/posts/${id}/${link}`);
        const data = response.data;

        const headingRegex = /<(h[1-2])([^>]*)>(.*?)<\/h[1-2]>/gi;
        let match;
        let h1Index = 0;
        let h2Index = 0;
        const headingStructure = [];
        let currentH1 = null;

        let modifiedContent = data.content;
        while ((match = headingRegex.exec(data.content)) !== null) {
          const [fullMatch, tag, attr, innerHtml] = match;
          const text = innerHtml.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();

          if (tag.toLowerCase() === "h1") {
            const id = `heading-${h1Index++}`;
            currentH1 = { id, text, children: [] };
            headingStructure.push(currentH1);
            modifiedContent = modifiedContent.replace(fullMatch, `<h1${attr} id="${id}">${innerHtml}</h1>`);
          } else if (tag.toLowerCase() === "h2" && currentH1) {
            const id = `subheading-${h2Index++}`;
            currentH1.children.push({ id, text });
            modifiedContent = modifiedContent.replace(fullMatch, `<h2${attr} id="${id}">${innerHtml}</h2>`);
          }
        }

        setParsedContent(parse(modifiedContent));
        setH1List(headingStructure);
        setPost(data);
      } catch (error) {
        console.error("Error fetching post:", error);
      }
    };

    fetchPost();
  }, [id]);

  const handleScrollTo = (id) => {
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (!post) return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <p>Loading...</p>
    </div>
  );

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3 border-end">
            <div className="position-sticky" style={{ top: '10px' }}>
              <h6 className="mt-3 ps-3">TÓM TẮT NỘI DUNG</h6>
              <ul className="list-unstyled ps-3">
                {h1List.length > 0 ? (
                  h1List.map((heading, idx) => (
                    <li key={idx} className="mb-2">
                      <button
                        onClick={() => handleScrollTo(heading.id)}
                        className="btn btn-link text-decoration-none text-dark p-0 fw-bold text-start"
                      >
                        {heading.text}
                      </button>
                      {heading.children.length > 0 && (
                        <ul className="list-unstyled ps-3">
                          {heading.children.map((sub, subIdx) => (
                            <li key={subIdx} className="mb-1">
                              <button
                                onClick={() => handleScrollTo(sub.id)}
                                className="btn btn-link text-decoration-none text-secondary p-0 text-start"
                              >
                                {sub.text}
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))
                ) : (
                  <li className="text-muted">Không tìm thấy tiêu đề</li>
                )}
              </ul>
            </div>
          </div>

          <div className="col-md-6 px-1">
            <div className="p-3">
              <div className="card p-3 w-100 shadow-sm border mb-3">
                <div className="card-body">
                  <h1 className="card-title">{post.title}</h1>
                  <div className="card-text">
                    {parsedContent}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3 border-start">
            <h6 className="mt-3 ps-3">CÓ THỂ BẠN QUAN TÂM</h6>
            <ul className="list-unstyled ps-3">
              {relatedArticles.map((article, idx) => (
                <li key={idx} className="mb-2">
                  <a href="#" className="text-decoration-none">{article}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <ScrollButton />

      <Footer />
    </div>
  );
};

export default PostDetail;
